import React, { Component } from "react";
import { Link } from "react-router-dom";

export class Navbar extends Component {
  render() {
    return (
  <div style={{ display: "flex",color: "skyblue",borderBottom:'0px solid #dfe4ea'
      }}>
        <Link to="/" style={{ textDecoration: "none" , marginLeft: "1rem" }} >
          <h1 class='Home'>Movies App</h1>
        </Link>
        <Link to="/favourites" style={{ textDecoration: "none" }}>
          <h2 style={{ marginLeft: "1rem", marginTop: "0.5rem" }} class='fav'>
            Favourites
          </h2>
        </Link>
      </div>
    );
  }
}

export default Navbar;
